import { createStore } from "vuex";

// Create a new store instance.
const store = createStore({
  state() {
    return {
      dialogFi: {
        ativo: false,
        pedido: {},
      },
      oldStatus: {},
      database: process.env.VUE_APP_DATABASE,
      produtos: [],
      categorias: [],
      pedidos: [],
      dadosEmpresa: {
        sitef: false
      },
      carrinho: [],
      horario: null,
      shownAlert: false,
      selecionado: `Delivery`,
      precoTotal: 0,
      busca: "",
      disableEncomenda: false,
      disableDelivery: false,
      bairros: [],
      scrollTo: "",
      metodosPgto: [],
      combos: [],
      selecionadoCategorias: 0,
      cidade: "Passo Fundo",
      carregando: false,
      logado: {
        data: {
          endereco: "",
          bairro: "",
          cidade: "Passo Fundo",
          nome: "",
          whatsapp: "",
          telefone: "",
          sobrenome: "",
        },
      },
      finalizaPedido: false,
      images: [],
      banner: false,
    };
  },
  mutations: {
    incrementOldStatus(state, dados) {
      state.oldStatus = dados;
    },
    incrementBanner(state, dados) {
      state.banner = dados;
    },
    incrementImages(state, dados) {
      state.images = dados;
    },
    incrementFinalizaPedido(state, dados) {
      state.finalizaPedido = dados;
    },
    incrementDialogFinanceiro(state, dados) {
      state.dialogFi = dados;
    },
    incrementCarregando(state, dados) {
      state.carregando = dados;
    },
    incrementLogado(state, dados) {
      state.logado = dados;
    },
    incrementShownAlert(state, dados) {
      state.shownAlert = dados;
    },
    incrementDatabase(state, dados) {
      state.database = dados;
    },
    incrementProdutos(state, dados) {
      state.produtos = dados;
    },
    incrementCategorias(state, dados) {
      state.categorias = dados;
    },
    incrementCarrinho(state, dados) {
      state.carrinho = dados;
    },
    incrementPedidos(state, dados) {
      state.pedidos = dados;
    },
    incrementDadosEmpresa(state, dados) {
      state.dadosEmpresa = dados;
    },
    incrementHorario(state, dados) {
      state.horario = dados;
    },
    incrementSelecionado(state, dados) {
      state.selecionado = dados;
    },
    incrementPrecoTotal(state, dados) {
      state.precoTotal = dados;
    },
    incrementBusca(state, dados) {
      state.busca = dados;
    },
    incrementDisableDelivery(state, dados) {
      state.disableDelivery = dados;
    },
    incrementDisableEncomenda(state, dados) {
      state.disableEncomenda = dados;
    },
    incrementBairros(state, dados) {
      state.bairros = dados;
    },
    incrementCidade(state, dados) {
      state.cidade = dados;
    },
    incrementScrollTo(state, dados) {
      state.scrollTo = dados;
    },
    incrementMetodosPgto(state, dados) {
      state.metodosPgto = dados;
    },
    incrementSelecionadoCategorias(state, dados) {
      state.selecionadoCategorias = dados;
    },
    incrementCombos(state, dados) {
      state.combos = dados;
    },
  },
  getters: {
    // ...
    oldStatus() {
      return store._state.data.oldStatus;
    },
    banner() {
      return store._state.data.banner;
    },
    images() {
      return store._state.data.images;
    },
    finalizaPedido() {
      return store._state.data.finalizaPedido;
    },
    dialogFi() {
      return store._state.data.dialogFi;
    },
    logado() {
      return store._state.data.logado;
    },
    shownAlert() {
      return store._state.data.shownAlert;
    },
    carregando() {
      return store._state.data.carregando;
    },
    combos() {
      return store._state.data.combos;
    },
    database() {
      return store._state.data.database;
    },
    produtos() {
      return store._state.data.produtos;
    },
    categorias() {
      return store._state.data.categorias;
    },
    carrinho() {
      return store._state.data.carrinho;
    },
    pedidos() {
      return store._state.data.pedidos;
    },
    dadosEmpresa() {
      return store._state.data.dadosEmpresa;
    },
    horario() {
      return store._state.data.horario;
    },
    selecionado() {
      return store._state.data.selecionado;
    },
    precoTotal() {
      return store._state.data.precoTotal;
    },
    busca() {
      return store._state.data.busca;
    },
    disableDelivery() {
      return store._state.data.disableDelivery;
    },
    disableEncomenda() {
      return store._state.data.disableEncomenda;
    },
    bairros() {
      return store._state.data.bairros;
    },
    cidade() {
      return store._state.data.cidade;
    },
    scrollTo() {
      return store._state.data.scrollTo;
    },
    metodosPgto() {
      return store._state.data.metodosPgto;
    },
    selecionadoCategorias() {
      return store._state.data.selecionadoCategorias;
    },
  },
});

export { store };
